import {Component, EventEmitter, Input, Output} from "@angular/core";


@Component({
    selector: "wbo-bi-drop-container",
    templateUrl: "./drop-container.component.html",
    styleUrls: ["./drop-container.component.scss"]
})
export class DropContainerComponent {

    @Input() title: string;

    @Input() icon: string;

    @Input() dropAreaLabel: string;

    @Input() droppable: boolean = true;
    @Input() showDropArea: boolean = true;

    @Input() dropZones: string[];

    @Input() message: string;

    @Output() onDrop: EventEmitter<any> = new EventEmitter<any>();


    public dropped(e: any): void {
        this.onDrop.next(e);
    }

}
